<template lang="pug">
v-container(style="max-width:960px")
  v-row.mt-sm-5(no-gutters)
    v-col(cols="12" sm="5")
      .d-flex.align-center
        v-text-field(v-model="searchText" @input="queryChanged" :placeholder="$t('search_transaction')" hide-details dense outlined height="40" :background-color="$colors.basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$colors.primary400")
    v-col(align="end")
      v-btn.button-sm(@click="openAddTransactionDialog = true" depressed dark color="neutral700") {{ $t('new') }}

  .yc-table
    v-data-table.mt-sm-4.pb-4(:headers="headers" :items="transactions" item-key="id" :items-per-page="pageSize" :loading="isLoading" hide-default-footer disable-sort)
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:item.lead="{ item, isMobile, headers, index }")
        div.font-semibold.py-3 {{ item.lead.name }}
      template(v-slot:item.channel="{ item, isMobile, headers, index }")
        div.py-3 {{ getPaymentMethod(item.channel) }}
      template(v-slot:item.amount="{ item, isMobile, headers, index }")
        div.py-3 {{ item.amount | displayPrice($currency) }}
      template(v-slot:item.actions="{ item, isMobile, headers, index }")
        div.py-3
          v-menu(offset-y left rounded="lg")
            template(#activator="{ on }")
              v-btn.ml-4(icon small v-on="on")
                v-icon mdi-dots-horizontal
            v-list(dense min-width="100")
              v-list-item(@click="openEditTransaction(item)")
                v-list-item-title.text-sm.neutral700--text {{ $t('edit') }}
              v-list-item(@click="openDeleteTransaction(item)")
                v-list-item-title.text-sm.danger500--text {{ $t('delete') }}
    .py-4
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('show_transaction')" @input="pageChanged")

  .dialogs
    add-new-transaction(v-if="openAddTransactionDialog" :open.sync="openAddTransactionDialog" @closed="closed" @reset="reset")
    edit-transaction(v-if="openEditTransactionDialog" :open.sync="openEditTransactionDialog" :selectedTransaction="selectedTransaction" @closed="closed" @reset="reset")
    delete-donation-dialog(v-if="openDeleteTransactionDialog" :open.sync="openDeleteTransactionDialog" :transaction="selectedTransaction" @closed="closed" @reset="reset")

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import AddNewTransaction from '@/components/donation/dialogs/AddNewTransaction.vue'
import EditTransaction from '@/components/donation/dialogs/EditTransaction.vue'
import DeleteDonationDialog from '@/components/donation/dialogs/DeleteDonationDialog.vue'

export default {
  name: 'ManageCampaignTransactions',
  props: [],
  components: { AddNewTransaction, EditTransaction, DeleteDonationDialog },
  data: () => ({
    isLoading: false,
    openAddTransactionDialog: false,
    openEditTransactionDialog: false,
    openDeleteTransactionDialog: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    transactions: [],
    selectedTransaction: null,
    options: [
      {
        text: 'Payment method',
        value: 'channel',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Donation value',
        value: 'amount',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Type',
        value: 'donation_cycle',
        enable: true,
        class: 'text-table-header text-end'
      },
      {
        text: '',
        value: 'actions',
        enable: true,
        class: 'text-table-header'
      },
      // {
      //   text: 'Link Click',
      //   value: 'created',
      //   enable: true
      // }
    ],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
    headers: {
      get () {
        const filteredOptions = this.options.filter(item => item.enable)
        const name = {
          text: 'Name',
          value: 'lead',
          class: 'text-table-header'
        }
        return [name, ...filteredOptions]
      }
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchTransactions(1)
    }
  },
  created() {
    this.fetchTransactions(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    getTransactions(page, pageSize, query) {
      const params = {
        page_size: pageSize,
        page,
        search: query || '',
        campaigns: this.campaign.id
      }
      return this.$axios.get(`/donations/${this.company.slug}/transactions`, { params })
    },
    fetchTransactions(page, query) {
      this.isLoading = true
      this.getTransactions(page, this.pageSize, query)
      .then(resp => {
        const data = resp.data
        this.transactions = data.results
        this.transactions.map(
          item => {
          item.checked = false
        })
        this.totalCount = data.count
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    pageChanged(num) {
      this.fetchTransactions(num)
    },
    queryChanged: debounce(function (query) {
      this.fetchTransactions(1, query)
    }, 750),
    openEditTransaction (item) {
      this.selectedTransaction = item
      this.openEditTransactionDialog = true
    },
    openDeleteTransaction (item) {
      this.selectedTransaction = item
      this.openDeleteTransactionDialog = true
    },
    closed () {
      this.selectedTransaction = null
    },
    reset () {
      this.selectedTransaction = null
      this.fetchTransactions(1)
    },
    getPaymentMethod (channel) {
      if (channel === 'fpx') {
        return 'Online banking'
      } else if (channel === 'cc') {
        return 'Credit/Debit card'
      } else if (channel) {
        return channel.substr(0,1).toUpperCase() + channel.substr(1)
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>